import axios from 'axios'

export default {
  // ======================================================================
  // ==========================List Management=============================
  // ======================================================================
  list (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/userorg')
        .then(({ data }) => {
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  // ==========================Socket Updates==============================
  async created (context, opts) {
    try {
      if (opts.organization && opts.user) {
        const updateOrg = context.rootState.Organization.current.id === opts.organization
        const updateUser = context.rootState.User.current.id === opts.user
        if (updateOrg || updateUser) {
          const { data } = await axios.get('/api/userorg', {
            params: {
              user: opts.user,
              organization: opts.organization,
              populate: ['user', 'organization']
            }
          })
          if (data) {
            if (updateOrg) {
              context.commit('Organization/ADD_USER', {
                id: data.id,
                firstName: data.user.firstName,
                lastName: data.user.lastName,
                email: data.user.email,
                alarmEmails: data.alarmEmails
              }, { root: true })
            }
            if (updateUser) {
              context.commit('User/ADD_ORGANIZATION', {
                id: data.id,
                organization: data.organization.name,
                alarmEmails: data.alarmEmails
              }, { root: true })
            }
          }
        }
      }
    } catch (err) {}
  },
  updated (context, opts) {
    // if it's in the list, go fetch its new details
    const updateOrgList = context.rootState.User.current && context.rootState.User.current.organizations.find(i => i.id === opts)
    const updateUserList = context.rootState.Organization.current && context.rootState.Organization.current.users.find(i => i.id === opts)
    if (updateOrgList || updateUserList) {
      axios
        .get(`/api/userorg/${opts}`, {
          params: {
            populate: ['user', 'organization']
          }
        })
        .then(({ data }) => {
          if (updateOrgList) {
            context.commit('User/UPDATE_ORGANIZATION', {
              id: data.id,
              organization: data.organization.name,
              alarmEmails: data.alarmEmails
            }, { root: true })
          }
          if (updateUserList) {
            context.commit('Organization/UPDATE_USER', {
              id: data.id,
              firstName: data.user.firstName,
              lastName: data.user.lastName,
              email: data.user.email,
              alarmEmails: data.alarmEmails
            }, { root: true })
          }
        }).catch()
    }
  },
  destroyed (context, opts) {
    // always try to remove from list
    context.commit('Organization/REMOVE_USER', opts.user, { root: true })
    context.commit('User/REMOVE_ORGANIZATION', opts.organization, { root: true })
  },
  // ===========================List Edits===============================
  add (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/userorg', opts)
        .then(({ data }) => {
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  delete (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/userorg/${opts}`)
        .then(({ data }) => {
          resolve(data)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  // ======================================================================
  // ==========================Item Management=============================
  // ======================================================================
  // detail (context, opts) {
  //   // return new Promise((resolve, reject) => {
  //   //   axios
  //   //     .get(`/api/userorg/${opts}`)
  //   //     .then(({ data }) => {
  //   //       context.commit('CURRENT', data)
  //   //       resolve(data)
  //   //     }).catch((error) => reject(error))
  //   // })
  // },
  update (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`/api/userorg/${opts.id}`, { alarmEmails: opts.alarmEmails })
        .then(({ data }) => {
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  unsubscribe (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/userorg/unsubscribe?token=${opts}`)
        .then(() => resolve())
        .catch((error) => reject(error))
    })
  }
}
